import { render, staticRenderFns } from "./ScoutingReportMatrixV2.vue?vue&type=template&id=9c56e690&scoped=true&"
import script from "./ScoutingReportMatrixV2.vue?vue&type=script&lang=ts&"
export * from "./ScoutingReportMatrixV2.vue?vue&type=script&lang=ts&"
import style0 from "./ScoutingReportMatrixV2.vue?vue&type=style&index=0&id=9c56e690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c56e690",
  null
  
)

export default component.exports